import { useContext } from 'react';
import { DeleteBankAccountModalContext } from './DeleteBankAccountModalContext';

export const useDeleteBankAccountModal = () => useContext(DeleteBankAccountModalContext);
